<script lang="ts">
	import { conditionInterpretator } from '../../helpers/scene_conditions_to_ui';

	import SingleRowView from '../../components/GenericView/SingleRowView.svelte';
	import type { DeviceConditionUI, DeviceTriggerUI } from '../../../../types/DeviceCondAndTriggerUI';
	import { _init_time_based_conditions } from '../../helpers/init_time_conditions';
	import type { TimeBasedConditionsUI } from '../../../../types/TimeBasedConditionsUI';
	import { extract_conditions_variables } from './extract_conditions_variables';
	import type { AutomationConditionUI } from '../../../../types/AutomationConditionUI';
	import type { SunriseSunsetConditionUI } from '../../../../types/SunriseSunsetConditionUI';
	import type { WeatherConditionUI } from '../../../../types/WeatherConditionUI';
	import type { EnergyExchangeConditionUI } from '../../../../types/EnergyExchangeConditionUI';
	import { Label, Stack } from '@Shelly/shelly-design-system';
	import { createEventDispatcher } from 'svelte';

	export let element; //only condition types will be here

	let purpose: string | undefined = element._gui_type || element._gui_purpose || undefined;

	let translated:
		| DeviceConditionUI
		| DeviceTriggerUI
		| TimeBasedConditionsUI
		| AutomationConditionUI
		| SunriseSunsetConditionUI
		| WeatherConditionUI
		| EnergyExchangeConditionUI
		| undefined = conditionInterpretator(element, purpose);

	const { title, withLabelList, labelList, conditionList, subtitle, avatar, description } =
		extract_conditions_variables(translated);

	const dispatch = createEventDispatcher();
</script>

<SingleRowView
	{withLabelList}
	{labelList}
	{avatar}
	{title}
	{subtitle}
	{description}
	on:click={() => {
		dispatch('edit-when');
	}}
/>

{#if conditionList && conditionList.length > 0}
	<Stack gap="s" class="mt-s">
		{#each conditionList as { icon, name }}
			<Label class="width-full justify-content-start" {icon} value={name} size="s" />
		{/each}
	</Stack>
{/if}
